<template>
  <UModal v-model="isOpen" preventClose :transition="false">
    <UCard>
      <div class="flex justify-end w-full">
        <BxX size="1.75rem" class="cursor-pointer text-slate-400 hover:text-slate-600 transition-colors" @click="closeModal" />
      </div>

      <div class="text-center px-4 pb-4">
        <h5 class="text-lg font-bold text-slate-900 m-0 mb-2">{{ heading }}</h5>
        <p class="text-sm text-slate-500 m-0 mb-6 leading-relaxed">{{ description }}</p>

        <div v-if="title || $slots.default" class="flex items-center justify-center bg-slate-50 rounded-lg p-4 mb-2 border border-slate-100">
          <h6 v-if="title" class="m-0 truncate max-w-[300px] font-semibold text-slate-700">{{ title }}</h6>
          <slot v-else></slot>
        </div>

        <div class="flex justify-center gap-3 w-full mt-8">
          <button class="px-5 py-2.5 text-sm font-semibold text-slate-700 bg-white hover:bg-slate-50 border border-slate-200 rounded-lg transition-all shadow-sm" @click="closeModal">
            {{ cancelButtonText }}
          </button>

          <button @click="confirmAction" :disabled="loadingBtn"
            class="relative inline-flex items-center justify-center px-5 py-2.5 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="confirm-button">
            <span v-if="loadingBtn" class="absolute inset-0 flex items-center justify-center">
              <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
            <span :class="{ 'opacity-0': loadingBtn }">{{ confirmButtonText }}</span>
          </button>
        </div>
      </div>
    </UCard>
  </UModal>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import BxX from "~/assets/svgs/BxX.vue";

import { useTranslate } from '~/composables/useTranslate';
const { t } = useTranslate();

const props = defineProps({
  heading: String,
  description: String,
  title: String,
  modelValue: Boolean,
  loadingBtn: Boolean,
  cancelButtonText: String,
  confirmButtonText: String,
  onClose: Function,
});


const heading = computed(() => props.heading || t("modal-warning-title"));
const description = computed(() => props.description || t("financial_statement_design_loss_warning"));
const cancelButtonText = computed(() => props.cancelButtonText || t("modal-cancel-button"));
const confirmButtonText = computed(() => props.confirmButtonText || t("modal-delete-button"));

const emit = defineEmits(["update:modelValue", "onConfirm"]);

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const closeModal = () => {
  if (props.onClose) {
    props.onClose();
  } else {
    isOpen.value = false;
  }
};

const confirmAction = () => {
  emit("onConfirm");
};
</script>